import { useSelector } from 'react-redux';

const useInSPA = () => {
    try {
        return useSelector(state => state.environment.featureSwitches['spa']);
    } catch {
        return false;
    }
};

export default useInSPA;
